import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { SaqueListItem } from '../../../types/saque';
import { formatDateTime, formatMoney } from './format';
import { SaqueStatusBadge } from './saque-status-badge';

interface Props {
  items: SaqueListItem[];
  onOpenDetail: (id: string) => void;
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.li`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

const Card = styled.button`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 6px;
  padding: 16px;
  background: transparent;
  border: none;
  border-radius: inherit;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / -1;
`;

const Cliente = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }

  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

const Valor = styled.div`
  display: flex;
  flex-direction: column;
  font-variant-numeric: tabular-nums;
  line-height: 1.3;

  strong {
    font-weight: 700;
    font-size: 16px;
  }

  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
    font-weight: 500;
  }
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 6px;
`;

export const SaquesCards = ({ items, onOpenDetail }: Props) => (
  <List>
    {items.map((saque) => (
      <Item key={saque.id}>
        <Card onClick={() => onOpenDetail(saque.id)} data-testid={`saque-card-${saque.id}`}>
          <Top>
            <Cliente>
              <strong>
                {saque.cliente.nome} {saque.cliente.sobrenome ?? ''}
              </strong>
              <small>{saque.cliente.email}</small>
            </Cliente>
            <SaqueStatusBadge
              status={saque.status}
              description={saque.statusDescricao}
            />
          </Top>
          <Valor>
            <strong>{formatMoney(saque.valor, saque.moeda)}</strong>
            <small>
              Líquido {formatMoney(saque.valorLiquido, saque.moedaDestino)}
            </small>
          </Valor>
          <Meta>
            <span>{formatDateTime(saque.createdAt)}</span>
            <ChevronRight size={16} />
          </Meta>
        </Card>
      </Item>
    ))}
  </List>
);
